export enum BRANCHES_COLUMN_NAME {
  TAKER = 'taker',
  TO_YOU = 'to_you',
}

export enum BRANCHES_COLUMN_NAME_TXT {
  TAKER = 'branch_matching_popup_taker_col_name',
  TO_YOU = 'branch_matching_popup_toyou_col_name',
}
